import { useState, useEffect } from 'react';
import { analyzePromptQuality } from '../utils/promptQuality';

/**
 * Hook zur Prompt-Qualitätswarnung mit 400ms Debounce.
 *
 * Gibt einen Warnungstext zurück, wenn der Prompt schwach formuliert ist,
 * oder null wenn alles OK ist.
 */
export function usePromptQualityWarning(text: string): string | null {
  const [warning, setWarning] = useState<string | null>(null);

  useEffect(() => {
    // Leerer Text → sofort null, kein Debounce
    if (!text.trim()) {
      setWarning(null);
      return;
    }

    const timer = setTimeout(() => {
      setWarning(analyzePromptQuality(text));
    }, 400);

    return () => clearTimeout(timer);
  }, [text]);

  return warning;
}
